module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-form', {
    ref: "form",
    staticClass: "demo-dynamic",
    attrs: {
      "label-width": "90px"
    }
  }, [_c('div', {
    staticClass: "ovf-auto",
    staticStyle: {
      "max-height": "600px"
    }
  }, _vm._l((_vm.selfHandle), function(option, index) {
    return _c('div', {
      staticClass: "bor-b-ccc m-b-10"
    }, [_c('el-form-item', {
      attrs: {
        "label": "操作名称"
      }
    }, [_c('el-input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (option.name),
        expression: "option.name"
      }],
      attrs: {
        "placeholder": "请输入名称"
      },
      domProps: {
        "value": (option.name)
      },
      on: {
        "input": function($event) {
          option.name = $event
        }
      }
    })]), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "按钮颜色"
      }
    }, [_c('el-select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (option.btn_color),
        expression: "option.btn_color"
      }],
      domProps: {
        "value": (option.btn_color)
      },
      on: {
        "input": function($event) {
          option.btn_color = $event
        }
      }
    }, _vm._l((_vm.btnColors), function(item) {
      return _c('el-option', {
        attrs: {
          "value": item.id,
          "label": item.name
        }
      })
    }))]), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "背景颜色"
      }
    }, [_c('el-select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (option.font_color),
        expression: "option.font_color"
      }],
      domProps: {
        "value": (option.font_color)
      },
      on: {
        "input": function($event) {
          option.font_color = $event
        }
      }
    }, _vm._l((_vm.fontColors), function(item) {
      return _c('el-option', {
        attrs: {
          "value": item.id,
          "label": item.name
        }
      })
    }))]), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "操作方式"
      }
    }, [_c('el-radio-group', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (option.deal_type),
        expression: "option.deal_type"
      }],
      domProps: {
        "value": (option.deal_type)
      },
      on: {
        "input": function($event) {
          option.deal_type = $event
        }
      }
    }, [_c('el-radio', {
      attrs: {
        "label": 10
      }
    }, [_vm._v("打开外链新页面")]), _vm._v(" "), _c('el-radio', {
      attrs: {
        "label": 20
      }
    }, [_vm._v("弹窗跳转功能集")]), _vm._v(" "), _c('el-radio', {
      attrs: {
        "label": 30
      }
    }, [_vm._v("页面跳转功能集")])]), _vm._v(" "), _c('div', {
      staticClass: "form-tips"
    }, [_vm._v("注：【弹窗跳转功能集】不支持跳转到有弹窗的功能集")])]), _vm._v(" "), (option.deal_type != _vm.SELFHANDLE_LINK) ? _c('div', [_c('el-form-item', {
      attrs: {
        "label": "参数"
      }
    }, [_c('el-select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (option.param),
        expression: "option.param"
      }],
      attrs: {
        "filterable": "",
        "placeholder": "请选择字段"
      },
      domProps: {
        "value": (option.param)
      },
      on: {
        "input": function($event) {
          option.param = $event
        }
      }
    }, _vm._l((_vm.fields), function(item) {
      return _c('el-option', {
        attrs: {
          "label": item.field,
          "value": item.field
        }
      }, [_c('span', [_vm._v(_vm._s(item.field) + "（" + _vm._s(item.title) + "）")])])
    }))]), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "实例"
      }
    }, [_c('el-input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (option.reality.name),
        expression: "option.reality.name"
      }],
      staticClass: "w-180",
      attrs: {
        "disabled": true
      },
      domProps: {
        "value": (option.reality.name)
      },
      on: {
        "change": function($event) {
          _vm.realityChange(option)
        },
        "input": function($event) {
          option.reality.name = $event
        }
      }
    }), _vm._v(" "), _c('el-button', {
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.openRealityDialog(option)
        }
      }
    }, [_vm._v("查找实例")])]), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "关联字段"
      }
    }, [_c('el-select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (option.fields),
        expression: "option.fields"
      }, {
        name: "loading",
        rawName: "v-loading",
        value: (_vm.loading),
        expression: "loading"
      }],
      attrs: {
        "filterable": "",
        "multiple": "",
        "placeholder": "请选择"
      },
      domProps: {
        "value": (option.fields)
      },
      on: {
        "input": function($event) {
          option.fields = $event
        }
      }
    }, [(option.reality.id && _vm.fieldsByModelId[option.reality.id]) ? _vm._l((_vm.fieldsByModelId[option.reality.id]), function(item) {
      return _c('el-option', {
        attrs: {
          "label": item.field + item.title,
          "value": item.field
        }
      }, [_c('span', [_vm._v(_vm._s(item.field) + "（" + _vm._s(item.title) + "）")])])
    }) : _vm._e()], true)])]) : _c('div', [_c('el-form-item', {
      attrs: {
        "label": "外链url"
      }
    }, [_c('el-input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (option.url),
        expression: "option.url"
      }],
      domProps: {
        "value": (option.url)
      },
      on: {
        "input": function($event) {
          option.url = $event
        }
      }
    })]), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "绑定权限规则"
      }
    }, [_c('el-input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (option.rule.name),
        expression: "option.rule.name"
      }],
      staticClass: "w-180",
      attrs: {
        "disabled": true
      },
      domProps: {
        "value": (option.rule.name)
      },
      on: {
        "input": function($event) {
          option.rule.name = $event
        }
      }
    }), _vm._v(" "), _c('el-button', {
      attrs: {
        "size": "small"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.openRuleDialog(option)
        }
      }
    }, [_vm._v("查找")]), _vm._v(" "), _c('el-button', {
      attrs: {
        "size": "small"
      },
      on: {
        "click": function($event) {
          _vm.clearRule(option)
        }
      }
    }, [_vm._v("清空")])])]), _vm._v(" "), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "可用条件",
        "prop": "has_condition"
      }
    }, [_c('el-radio-group', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (option.has_condition),
        expression: "option.has_condition"
      }],
      domProps: {
        "value": (option.has_condition)
      },
      on: {
        "input": function($event) {
          option.has_condition = $event
        }
      }
    }, [_c('el-radio', {
      attrs: {
        "label": 0
      }
    }, [_vm._v("无限制")]), _vm._v(" "), _c('el-radio', {
      attrs: {
        "label": 1
      }
    }, [_vm._v("条件限制")])])]), _vm._v(" "), _c('el-form-item', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.showCondition(option)),
        expression: "showCondition(option)"
      }]
    }, [_c('el-select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (option.condition.field_id),
        expression: "option.condition.field_id"
      }],
      staticClass: "fl w-150 m-r-10 m-b-10",
      attrs: {
        "filterable": "",
        "placeholder": "字段名"
      },
      domProps: {
        "value": (option.condition.field_id)
      },
      on: {
        "input": function($event) {
          option.condition.field_id = $event
        }
      }
    }, _vm._l((_vm.fields), function(item) {
      return _c('el-option', {
        attrs: {
          "label": item.field + '(' + item.title + ')',
          "value": item.field_id
        }
      })
    })), _vm._v(" "), _c('el-select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (option.condition.logic),
        expression: "option.condition.logic"
      }],
      staticClass: "fl w-150 m-r-10 m-b-10",
      attrs: {
        "placeholder": "计算公式"
      },
      domProps: {
        "value": (option.condition.logic)
      },
      on: {
        "input": function($event) {
          option.condition.logic = $event
        }
      }
    }, _vm._l((_vm.logicTypes), function(item) {
      return _c('el-option', {
        attrs: {
          "label": item.name,
          "value": item.id
        }
      })
    })), _vm._v(" "), _c('el-input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (option.condition.value),
        expression: "option.condition.value"
      }],
      staticClass: "fl w-150 m-r-10 m-b-10",
      attrs: {
        "placeholder": "值"
      },
      domProps: {
        "value": (option.condition.value)
      },
      on: {
        "input": function($event) {
          option.condition.value = $event
        }
      }
    }), _vm._v(" "), _c('el-select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (option.condition.auth),
        expression: "option.condition.auth"
      }],
      staticClass: "fl w-150 m-r-10 m-b-10",
      attrs: {
        "placeholder": "对应情况"
      },
      domProps: {
        "value": (option.condition.auth)
      },
      on: {
        "input": function($event) {
          option.condition.auth = $event
        }
      }
    }, _vm._l((_vm.authTypes), function(item) {
      return _c('el-option', {
        attrs: {
          "label": item.name,
          "value": item.id
        }
      })
    }))]), _vm._v(" "), _c('div', {
      staticClass: "m-b-10"
    }, [_c('el-button', {
      attrs: {
        "disabled": index == 0
      },
      on: {
        "click": function($event) {
          _vm.sortUp(index)
        }
      }
    }, [_vm._v("上移")]), _vm._v(" "), _c('el-button', {
      attrs: {
        "disabled": index == _vm.selfHandle.length - 1
      },
      on: {
        "click": function($event) {
          _vm.sortDown(index)
        }
      }
    }, [_vm._v("下移")]), _vm._v(" "), _c('el-button', {
      on: {
        "click": function($event) {
          _vm.deleteSelfHandle(index)
        }
      }
    }, [_vm._v("删除")])])])
  })), _vm._v(" "), _c('div', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.addSelfHandle
    }
  }, [_vm._v("增加一个")])])]), _vm._v(" "), _c('rule-list', {
    ref: "ruleList",
    on: {
      "selectRule": _vm.selectRule
    }
  }), _vm._v(" "), _c('reality-list', {
    ref: "realityList",
    attrs: {
      "title": _vm.title
    },
    on: {
      "selectReality": _vm.selectReality
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5acca598!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Content/classify/selfHandleConfig.vue
// module id = 1872
// module chunks = 2